// internal-deps
import { RegisterOverlaysArgs } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

export const getHighestElement = (queue: RegisterOverlaysArgs[]): RegisterOverlaysArgs | null => {
    if (isEmpty(queue)) {
        return null;
    }

    return (queue as RegisterOverlaysArgs[])?.reduce((prev, curr) => {
        return prev.priority < curr.priority ? prev : curr;
    });
};
